import darkPalette from './darkPalette';
import fontsByName from './fontsByName';
import ThemeImpl from './ThemeImpl';

export default new ThemeImpl(true, darkPalette, fontsByName);
